@let currentUser = authentication.currentUser$ | async;
@let isGuest = currentUser?.userType === UserType.GUEST;
@let isScreeningLinkSession = currentUser?.userType === UserType.SCREENING_LINK_SESSION;

<div class="one-row-menu" [ngClass]="{'two-rows-menu-desktop-only': isUserRH && !isRestrictedToSinglePage}"></div>
<div class="header-container" [ngClass]="{'header-bottom': !isUserRH || isRestrictedToSinglePage}" role="navigation" aria-label="main navigation header">
  <!-- menu -->
  <div class="regular-menu one-row-menu">
    <div class="burger-container mobile-only">
      @if (!isRestrictedToSinglePage) {
        @if (navBar.isToggled) {
          <button mat-icon-button class="icon-button" (click)="navBar.dismiss()" aria-label="main menu close">
            <lucide-icon name="x"></lucide-icon>
          </button>
        } @else {
          <button mat-icon-button class="icon-button" (click)="navBar.open();dismissSearch()" aria-label="main menu open">
            <lucide-icon name="menu"></lucide-icon>
          </button>
        }
      }
    </div>
    <div class="logo-container">
      <a routerLink="/">
        <h1>
          <img src="assets/mat-icon/logo-festival-scope-pro-white.svg" alt="Festival Scope Pro" class="logo desktop-only">
          <img src="assets/images/logo-mobile-festival-scope-pro-white.svg" alt="Festival Scope Pro" class="logo mobile-only">
        </h1>
      </a>
    </div>
    <!-- search -->
    <div class="search-container">
      @if (!isRestrictedToSinglePage) {
        @if (displaySearchPopup) {
          <button mat-icon-button class="icon-button search-button" (click)="displaySearchPopup=!displaySearchPopup" aria-label="close search">
            <lucide-icon name="circle-x"></lucide-icon>
          </button>
        } @else {
          <button mat-icon-button class="icon-button search-button" (click)="displaySearchPopup=!displaySearchPopup" aria-label="open search">
            <lucide-icon name="search"></lucide-icon>
          </button>
        }
      }

    </div>
    <div class="center-container" [style.width]="!navBar.isToggled ? 0 : null" [style.height]="!navBar.isToggled? 0 : null">
      <fspro-navbar
        #navBar
        [isUserRH]="isUserRH"
        [isRestrictedToSinglePage]="isRestrictedToSinglePage"
      ></fspro-navbar>
    </div>
    <!-- user space -->
    <ul class="user-space-container">
      @if (!isRestrictedToSinglePage) {
        @if (currentUser && currentUser.userType !== UserType.GUEST) {
        <!-- upgrade / renew -->
        <li class="uppercase mobile-hide">
          <a routerLink="/subscribe" *ngIf="currentUser.canCreateSubscription">
            <button mat-stroked-button class="upgrade-button">
              <span>{{ (currentUser.shouldUpdate === 'renew' ? 'fspro.front.renew_action' : 'fspro.front.upgrade_action') | translate }}</span>
            </button>
          </a>
        </li>
        } @else {
        <!-- join -->
        <li class="uppercase mobile-hide">
          <a routerLink="/sign-up">
            <button mat-stroked-button class="join-button">
              <span>{{ 'fspro.front.header.nav.label.join' | translate }}</span>
            </button>
          </a>
        </li>
        }
        <li class="uppercase mobile-hide">
          <a class="hover-grey" routerLink="/newsletter/form">{{'fspro.front.header.user_feature.label.newsletter' | translate}}</a>
        </li>
        <li>
          <div data-controller="openbubble" #rubixToggle class="pageheader__rubixbox" (click)="rubixBox.toggle()">
            <button mat-icon-button class="icon-button grip-button" aria-label="additional menu with user lists">
              <lucide-icon name="grip"></lucide-icon>
            </button>
            <fspro-bubble #rubixBox type="rubix" [classes]="['rubixbox', 'posname-rubiks']">
              <fspro-user-features-box></fspro-user-features-box>
            </fspro-bubble>
          </div>
        </li>
      }
      @if (currentUser) {
        <li>
          <div class="pageheader__myaccount pageheader__myaccount--loggedin" #myAccountBoxToggle (click)="dismissSearch(); myAccountBox.toggle()">
            <div class="pageheader__userprofile pageheader__userprofile--loggedin">
              <button mat-icon-button class="icon-button user-button" aria-label="user features menu">
                <lucide-icon name="user-round"></lucide-icon>
              </button>
            </div>
            <fspro-bubble #myAccountBox type="section" [classes]="['myaccountbox', 'posname-user-info']">
              @if (isScreeningLinkSession) {
                {{ 'fspro.front.header.nav.label.screening_reference' | translate }}
              }
              <h1 class="myaccountbox__username" [innerHTML]="displayedFullname"></h1>
              @if (!isScreeningLinkSession) {
                <p *ngIf="isGuest">{{ 'fspro.front.header.nav.label.sign_in_as_guest' | translate }}
                </p>
                <p class="myaccountbox__registeredmail">
                  <span *ngIf="isGuest">(</span>{{ (authentication._impersonation$ | async) ?
                  'Impersonating ' + authentication.impersonatedEmail : user?.username}}<span *ngIf="isGuest">)</span>
                </p>
                <p *ngIf="!isGuest"><a class="myaccountbox__myinfolink" routerLink="/my-account/my-infos">{{'fspro.front.header.nav.label.my_info' | translate }}</a></p>
                <p *ngIf="isGuest">{{ 'fspro.front.header.nav.label.guest_has_an_account' | translate }}</p>
                <p><a class="myaccountbox__myinfolink" *ngIf="stripePortalUrl" href="{{ stripePortalUrl }}">{{'fspro.front.header.nav.label.my_invoicing' | translate}}</a></p>
              }
              <div class="myaccountbox__extras">
                <a class="myaccountbox__signout" *ngIf="authentication._impersonation$ | async" href="javascript:void(0)" (click)="authentication.exitImpersonation()">Exit impersonation</a>
                <a class="myaccountbox__signout" *ngIf="!(authentication._impersonation$ | async)" href="javascript:void(0)" (click)="onSignOut()">
                  <span *ngIf="!isGuest">{{'fspro.front.header.nav.label.sign_out' | translate}}</span>
                  <span *ngIf="isGuest">{{'fspro.front.header.nav.label.sign_out_guest' |translate}}</span>
                </a>
              </div>
            </fspro-bubble>
          </div>
        </li>
      } @else {
        <!-- sign-in -->
        <li class="uppercase">
          <a (click)="goToLogin()" class="hover-grey" *ngIf="!currentUser">
            <div class="sign-in-button hover-grey">
              <span>{{ 'fspro.front.header.top.label.login' | translate }}</span>
            </div>
          </a>
        </li>
      }
    </ul>
  </div>

  <search-popup *ngIf="displaySearchPopup" (onSearchChanged)="dismissSearch()"></search-popup>
</div>
